<template>
  <div>
    <!-- TABLE HISTORIQUE -->
    <div class="content">
      <div class="block">
        <div class="block-content block-content-full">
          <table class="table table-striped table-vcenter table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>N° de facture</th>
                <th>Montant HT</th>
                <th>Montant TTC</th>
                <th class="text-center">Voir</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="invoice in invoices" :key="invoice.id">
                <!-- date -->
                <td>{{ formatDate(invoice.created_at) }}</td>
                <!-- Type -->
                <td>
                    <span v-if="invoice.type === 'invoice'" class="badge bg-success-light text-success rounded-pill">Facture</span>
                    <span v-else-if="invoice.type === 'deposit'" class="badge bg-success-light text-success rounded-pill">Acompte</span>
                    <span v-else-if="invoice.type === 'credit_note'" class="badge bg-primary rounded-pill">Avoir</span>
                </td>
                <!-- Invoice number -->
                 <td>
                    {{ invoice.serial_number}}
                </td>
                <!-- HT amount -->
                <td>
                  {{ formatPrice(invoice.total_ht) }}
                </td>
                <!-- TTC Amount -->
                 <td>
                  {{ formatPrice(invoice.total_ttc) }}
                </td>
                <!-- open -->
                <td class="text-center">
                    <button type="button" class="od-row-action" @click="openInvoice(invoice)">
                        Voir
                    </button>
                </td>
                <td class="text-center">
                    <button
                        v-if="canCancelForCorrection(invoice)"
                        type="button"
                        class="od-row-action is-danger"
                        :disabled="cancellingInvoiceId === invoice.id"
                        @click="openCancelDialog(invoice)"
                    >
                        <span v-if="cancellingInvoiceId === invoice.id" class="od-dialog-spinner" aria-hidden="true"></span>
                        Annuler et refaire
                    </button>
                </td>
                </tr>

              <tr v-if="!invoices.length">
                <td colspan="7" class="text-center text-muted w-100">
                  Aucune factures
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="cancelDialog"
      max-width="620"
      persistent
      content-class="od-dialog"
      overlay-color="#171b23"
      overlay-opacity="0.55"
      transition="invoice-cancel-slide-y-transition"
    >
      <div class="od-dialog-card">
        <div class="catalogue-modal-header">
          <div>
            <p class="catalogue-modal-eyebrow">Facture {{ selectedCancelInvoice ? selectedCancelInvoice.serial_number : '' }}</p>
            <h2 class="catalogue-modal-title">Annuler et refaire</h2>
            <p class="catalogue-modal-subtitle">Un avoir total est créé et les paiements liés sont remboursés par leur moyen d'origine.</p>
          </div>
          <button type="button" class="catalogue-modal-close" aria-label="Fermer" :disabled="cancelLoading" @click="closeCancelDialog">
            <img src="/media/svg/handoff-icons/svg/x.svg" alt="" aria-hidden="true">
          </button>
        </div>

        <div v-if="selectedCancelInvoice" class="catalogue-modal-body">
          <div class="od-dialog-summary">
            <div>
              <div class="od-dialog-summary-label">Facture à annuler</div>
              <div class="od-dialog-summary-value">{{ selectedCancelInvoice.serial_number }}</div>
              <div class="od-dialog-summary-meta">{{ formatDate(selectedCancelInvoice.created_at) }}</div>
            </div>
            <span class="od-dialog-pill is-success">Acompte</span>
          </div>

          <div class="od-dialog-note">
            Si besoin, ouvrez ensuite le panier pour refaire l'encaissement.
          </div>

          <div class="od-dialog-field">
            <label class="catalogue-modal-label" :for="`od-cancel-note-${_uid}`">Motif *</label>
            <textarea
              :id="`od-cancel-note-${_uid}`"
              v-model="cancelNote"
              class="catalogue-modal-input"
              rows="3"
              maxlength="500"
              placeholder="Exemple : erreur de saisie du montant encaissé"
            ></textarea>
            <div class="od-dialog-help"><span>3 caractères minimum</span><span>{{ cancelNote.length }}/500</span></div>
          </div>

          <div class="od-dialog-totals">
            <div class="od-dialog-total"><span>Total HT annulé</span><strong>{{ formatPrice(selectedCancelInvoice.total_ht) }}</strong></div>
            <div class="od-dialog-total"><span>Total TVA annulé</span><strong>{{ formatPrice(selectedCancelInvoice.total_tva) }}</strong></div>
            <div class="od-dialog-total is-main"><span>Total de l'avoir TTC</span><strong>{{ formatPrice(selectedCancelInvoice.total_ttc) }}</strong></div>
          </div>

          <div v-if="cancelApiError" class="od-dialog-error">{{ cancelApiError }}</div>
        </div>

        <div class="catalogue-modal-footer">
          <button type="button" class="catalogue-modal-cancel" :disabled="cancelLoading" @click="closeCancelDialog">Annuler</button>
          <button type="button" class="catalogue-modal-submit" :disabled="!canConfirmCancel || cancelLoading" @click="confirmCancelForCorrection">
            <span v-if="cancelLoading" class="od-dialog-spinner" aria-hidden="true"></span>
            Confirmer l'avoir
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- DIALOG -->
    <v-dialog
      v-model="dialog"
      max-width="560"
      persistent
      content-class="od-dialog"
      overlay-color="#171b23"
      overlay-opacity="0.55"
      transition="invoice-cancel-slide-y-transition"
    >
      <div class="od-dialog-card">
        <div class="catalogue-modal-header">
          <div>
            <p class="catalogue-modal-eyebrow">Paiement</p>
            <h2 class="catalogue-modal-title">Corriger une erreur de saisie</h2>
            <p class="catalogue-modal-subtitle">Le paiement saisi est annulé puis recréé avec le moyen et le montant corrigés.</p>
          </div>
          <button type="button" class="catalogue-modal-close" aria-label="Fermer" :disabled="loading" @click="closeDialog">
            <img src="/media/svg/handoff-icons/svg/x.svg" alt="" aria-hidden="true">
          </button>
        </div>

        <div v-if="selected" class="catalogue-modal-body">
          <div class="od-dialog-summary">
            <div>
              <div class="od-dialog-summary-label">Paiement d'origine</div>
              <div class="od-dialog-summary-value">
                {{ selected.payment_method?.name || 'Non spécifié' }} · {{ formatPrice(selected.amount) }}
              </div>
              <div class="od-dialog-summary-meta">{{ formatDate(selected.created_at) }}</div>
            </div>
            <span class="od-dialog-pill is-warning">Correction</span>
          </div>

          <div class="od-dialog-field">
            <label class="catalogue-modal-label" :for="`od-correction-method-${_uid}`">Nouveau moyen de paiement</label>
            <select :id="`od-correction-method-${_uid}`" v-model="selectedMethod" class="catalogue-modal-select" :disabled="methodsLoading">
              <option :value="null" disabled>{{ methodsLoading ? 'Chargement…' : 'Choisir un moyen de paiement' }}</option>
              <option v-for="method in methods" :key="method.id" :value="method.id">{{ method.name }}</option>
            </select>
          </div>

          <div class="od-dialog-field">
            <label class="catalogue-modal-label" :for="`od-correction-amount-${_uid}`">Montant corrigé</label>
            <div class="od-dialog-suffix">
              <input
                :id="`od-correction-amount-${_uid}`"
                v-model="amount"
                type="number"
                step="0.01"
                min="0.01"
                :max="Math.abs(selected.amount)"
                class="catalogue-modal-input"
                :class="{ 'is-invalid': amountError }"
              >
              <span>€</span>
            </div>
            <div v-if="amountError" class="od-dialog-help is-error">{{ amountError }}</div>
          </div>

          <div class="od-dialog-field">
            <label class="catalogue-modal-label" :for="`od-correction-note-${_uid}`">Explication</label>
            <textarea
              :id="`od-correction-note-${_uid}`"
              v-model="note"
              class="catalogue-modal-input"
              rows="3"
              maxlength="500"
              placeholder="Exemple : erreur de saisie du montant encaissé"
            ></textarea>
            <div class="od-dialog-help"><span>Facultatif</span><span>{{ (note || '').length }}/500</span></div>
          </div>

          <div v-if="apiError" class="od-dialog-error">{{ apiError }}</div>
        </div>

        <div class="catalogue-modal-footer">
          <button type="button" class="catalogue-modal-cancel" :disabled="loading" @click="closeDialog">Annuler</button>
          <button type="button" class="catalogue-modal-submit" :disabled="!canSubmit || loading" @click="submit">
            <span v-if="loading" class="od-dialog-spinner" aria-hidden="true"></span>
            Corriger le paiement
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import "moment/locale/fr"

export default {
  props: {
    invoices: {
      type: Array,
      default: () => []
    },
    facInvoiceRoute: {
        type: String,
        default: ''
    }
  },

  data() {
    return {
      dialog: false,
      selected: null,

      methods: [],
      methodsLoading: false,
      selectedMethod: null,

      amount: null,
      note: "",

      loading: false,
      apiError: null,
      cancellingInvoiceId: null,
      cancelDialog: false,
      selectedCancelInvoice: null,
      cancelNote: "",
      cancelLoading: false,
      cancelApiError: null,

      rules: {
        required: v => !!v || "Champ requis",
        minCancelNote: v => (v && v.trim().length >= 3) || "Minimum 3 caractères",
        maxNote: v => !v || v.length <= 500 || "Maximum 500 caractères",
        float: v => {
          const n = parseFloat(v)
          return !isNaN(n) || "Montant invalide"
        },
        positive: v => parseFloat(v) > 0 || "Le montant doit être supérieur à 0",
        maxSelectedAmount: v => {
          const max = Math.abs(parseFloat(this.selected?.amount || 0))
          return parseFloat(v) <= max || `Maximum ${max.toFixed(2)} €`
        },
      }
    }
  },

  computed: {
    amountError() {
      if (!this.selected || this.amount === null || this.amount === '') return ''
      const value = parseFloat(this.amount)
      const max = Math.abs(parseFloat(this.selected.amount || 0))
      if (isNaN(value)) return 'Montant invalide'
      if (value <= 0) return 'Le montant doit être supérieur à 0'
      if (value > max) return `Maximum ${max.toFixed(2)} €`
      return ''
    },
    canSubmit() {
      return (
        this.selected &&
        this.selectedMethod &&
        this.amount !== null &&
        !isNaN(parseFloat(this.amount)) &&
        parseFloat(this.amount) > 0 &&
        parseFloat(this.amount) <= Math.abs(parseFloat(this.selected.amount))
      )
    },
    canConfirmCancel() {
      return this.selectedCancelInvoice
        && this.cancelNote
        && this.cancelNote.trim().length >= 3
        && this.cancelNote.length <= 500
    }
  },

  methods: {
    async openDialog(invoice) {
      this.selected = invoice
      this.amount = invoice.amount
      this.note = ""
      this.apiError = null
      this.dialog = true

      await this.loadMethods()

      this.selectedMethod = invoice.payment_method_id
      console.log(invoice)
    },

    // open fac
    openInvoice(invoice) {
        console.log
        window.open(`/back-office/factures/${invoice.id}`, '_blank')
    },

    canCancelForCorrection(invoice) {
      return invoice
        && invoice.serie === 'FA'
        && invoice.type === 'deposit'
        && !invoice.reference_invoice_id
        && !invoice.settlement_invoice_id
        && !this.hasStripePayment(invoice)
        && !this.invoices.some(candidate => (
          candidate.type === 'credit_note'
          && parseInt(candidate.reference_invoice_id, 10) === parseInt(invoice.id, 10)
        ))
    },

    hasStripePayment(invoice) {
      if (invoice.has_stripe_payment) return true

      return (invoice.payments || []).some(payment => (
        String(payment.payment_method?.name || '').trim().toLowerCase() === 'stripe'
        || !!payment.payment_intent_id
      ))
    },

    openCancelDialog(invoice) {
      this.selectedCancelInvoice = invoice
      this.cancelNote = ""
      this.cancelApiError = null
      this.cancelDialog = true
    },

    closeCancelDialog() {
      if (this.cancelLoading) return

      this.cancelDialog = false
      this.selectedCancelInvoice = null
      this.cancelNote = ""
      this.cancelApiError = null
    },

    async confirmCancelForCorrection() {
      if (!this.canConfirmCancel) return

      const invoice = this.selectedCancelInvoice
      this.cancellingInvoiceId = invoice.id
      this.cancelLoading = true
      this.cancelApiError = null

      try {
        const res = await axios.post('/back-office/caisse/invoices/cancel-for-correction', {
          invoice_id: invoice.id,
          note: this.cancelNote.trim(),
        })

        if (res.data?.checkout_url) {
          window.location.href = res.data.checkout_url
          return
        }

        window.location.reload()
      } catch (e) {
        this.cancelApiError = e?.response?.data?.message || "Impossible d'annuler cette facture."
      } finally {
        this.cancellingInvoiceId = null
        this.cancelLoading = false
      }
    },

    closeDialog() {
      this.dialog = false
      this.selected = null
      this.amount = null
      this.note = ""
      this.selectedMethod = null
      this.apiError = null
    },

    async loadMethods() {
      this.methodsLoading = true
      try {
        const res = await axios.get('/back-office/paiement-method/list')
        this.methods = (res.data || []).filter(method => !method.hidden)
      } catch (e) {
        this.apiError = "Impossible de charger les méthodes de paiement."
      } finally {
        this.methodsLoading = false
      }
    },

    async submit() {
      if (!this.canSubmit) return

      this.loading = true
      this.apiError = null
      console.log('im in');
      try {
        await axios.post('/back-office/caisse/errorOrderInvoice', {
          payment_id: this.selected.id, // id de la transaction
          method_id: this.selectedMethod, // new payment method
          original_payment_method_id: this.selected.payment_method_id, // id original
          amount: parseFloat(this.amount),
          note: this.note,
          update_order: false,
        })

        this.closeDialog()
        window.location.reload()
      } catch (e) {
        this.apiError =
          e?.response?.data?.message || "Une erreur est survenue."
      } finally {
        this.loading = false
      }
    },

    formatDate(date) {
      moment.locale('fr')
      return moment(date).format('DD/MM/YYYY HH:mm')
    },

    formatPrice(price) {
      const value = Math.abs(parseFloat(price || 0))
      return value.toFixed(2) + " €"
    }
                
  }
}
</script>

<style src="./order-dialog.css"></style>

<style scoped>
::v-deep .invoice-cancel-slide-y-transition-enter-active,
::v-deep .invoice-cancel-slide-y-transition-leave-active {
  transition: opacity .22s ease, transform .22s ease;
}

::v-deep .invoice-cancel-slide-y-transition-enter,
::v-deep .invoice-cancel-slide-y-transition-leave-to {
  opacity: 0;
  transform: translateY(-32px);
}

::v-deep .invoice-cancel-slide-y-transition-enter-to,
::v-deep .invoice-cancel-slide-y-transition-leave {
  opacity: 1;
  transform: translateY(0);
}
</style>
